import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const fibAssessmentSliceApi = createApi({
  reducerPath: "fibAssessmentApi",
  baseQuery: customBaseQuery,
  //   keepUnusedDataFor: 60,
  //   tagTypes: ["attendanceApi"],
  endpoints: (builder) => ({
    getFibAssessmentApi: builder.query({
      query: ({ questionId, version, status }) => ({
        url: `/fib/${questionId}/${version}/${status}`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    addFibSubtypeAssessmentApi: builder.mutation({
      query: ({ subtype, access, data }: any) => ({
        url: `/fib/${subtype}/${access}`,
        method: "POST",
        body: data
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateFibAssessmentApi: builder.mutation({
      query: ({ questionId, version, data }: any) => ({
        url: `/fib/${questionId}/${version}`,
        method: "PUT",
        body: data
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateFibStatusApi: builder.mutation({
      query: ({ questionId, version, data }: any) => ({
        url: `/fib/${questionId}/status/${version}`,
        method: "PUT",
        body: data
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    fibNewVersion: builder.mutation({
      query: ({ version, questionId, status }: any) => ({
        url: `/fib/version/${questionId}/${version}/${status}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    fibClone: builder.mutation({
      query: ({ version, questionId, status }: any) => ({
        url: `/fib/clone/${questionId}/${version}/${status}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    })
  })
});

export const {
  useGetFibAssessmentApiQuery,
  useLazyGetFibAssessmentApiQuery,
  useAddFibSubtypeAssessmentApiMutation,
  useUpdateFibAssessmentApiMutation,
  useFibNewVersionMutation,
  useUpdateFibStatusApiMutation,
  useFibCloneMutation
} = fibAssessmentSliceApi;
